import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import './ContactMain.scss';

class ContactMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = (text) => {
    const { loadTranslations, currentLanguage } = this.props;
    return loadTranslations(text, currentLanguage);
  };

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <div className="contact-details">
          <div style={{ textTransform: 'uppercase', fontWeight: '600' }}><h4 className="margin-bottom10">LAGEPLAN</h4></div>
          <h5 className="line-height2">Die Gruppenpraxis befindet sich im EG an der Neuhardstrasse 38, Olten.</h5>
          <hr />
          <div><h4 className="margin-bottom10 margin-top">Anfahrt mit öffentlichen Verkehrsmitteln</h4></div>
          <h5 className="line-height2">Wir sind zu Fuss nur wenige Minuten vom Bahnhof Olten SBB erreichbar (Ausgang Hardfeld-Bifang / Bildungsstadt).</h5>
          <hr />
          <div><h4 className="margin-bottom10 margin-top">Anfahrt mit privaten Verkehrsmitteln</h4></div>
          <h5 className="line-height2">Im Parkhaus Neuhard neben unserem Praxisgebäude sind ausreichend kostenpflichtige Parkplätze vorhanden (Zufahrt Neuhardstrasse 34).</h5>
        </div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2703.1332639312795!2d7.9079420150254425!3d47.35079611360798!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47903035012798f5%3A0x1e7ecbcad28ba316!2sNeuhardstrasse%2038%2C%204600%20Olten%2C%20Switzerland!5e0!3m2!1sen!2sin!4v1605766680055!5m2!1sen!2sin" width="100%" height="335" frameborder="0" style={{ border: 0 }} allowfullscreen="" ariaHidden="false" tabindex="0"></iframe>
      </div>
      //      <div style={{ position: 'relative' }}>
      //      <div className="contact-details">
      //        <div style={{textTransform: 'uppercase'}}><h3 className="margin-bottom">Kontakt Gruppenpraxis Neuhard</h3></div>
      //        <h4 className="margin-bottom10"><i className="fas fa-phone margin-right" /> 062 296 50 55</h4>
      //        <h4 className="margin-bottom10"><i class="fas fa-envelope-open-text margin-right" /> gruppenpraxis.neuhard@hin.ch</h4>
      //        <h5>(Keine medizinische Auskunft und keine Terminvereinbarungen per Email)</h5>
      //        <hr />
      //        <div style={{textTransform: 'uppercase'}}><h3 className="margin-bottom10 margin-top">Kontakt Physiotherapie</h3></div>
      //        <h5 className="margin-bottom10">Termine nach Vereinbarung</h5>
      //        <h4 className="margin-bottom10"><i class="fas fa-phone margin-right" /> 062 296 06 97</h4>
      //        <h4 className="margin-bottom10"><i class="fas fa-envelope-open-text margin-right" /> physio.regula.schneider@bluewin.ch</h4>
      //      </div>
      //      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2703.1332639312795!2d7.9079420150254425!3d47.35079611360798!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47903035012798f5%3A0x1e7ecbcad28ba316!2sNeuhardstrasse%2038%2C%204600%20Olten%2C%20Switzerland!5e0!3m2!1sen!2sin!4v1605766680055!5m2!1sen!2sin" width="100%" height="300" frameborder="0" style={{ border:0 }} allowfullscreen="" ariaHidden="false" tabindex="0"></iframe>
      //  </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(ContactMain);



// WEBPACK FOOTER //
// ./screens/ContactMain/ContactMain.js